export function emailValidationOptions() {
  return {
    allow_display_name: false, // "Display Name <email@example.com>" の形式を許可
    require_display_name: false, // 表示名を必須にするか（false なら不要）
    allow_utf8_local_part: false, // ローカル部分（@の前）でUTF-8文字を許可
    require_tld: true, // ドメインにトップレベルドメイン（例: .com）を必須にする
    allow_ip_domain: false, // ドメインにIPアドレス（例: test@[192.168.0.1]）を許可するか
    domain_specific_validation: false, // Gmail独自のバリデーションを適用
    blacklisted_chars: '*', // ローカル部分で禁止する文字を指定
    host_blacklist: [], // 無効にしたいドメイン名をリストで指定
    ignore_max_length: false, // メールアドレスの最大長制限（320文字）を無視するか
  };
}
